module.exports = __webpack_public_path__ + "static/media/TG.147a647c.png";